<template lang="pug">
  .container.grid-lg
    .columns.py-2.align-end
      .column.col-mr-auto
        form(@submit.prevent="search")
          .columns
            .column.col-mr-auto
              .form-group
                small Pesquisa
                input.form-input.input-sm(type='text' v-model="nome_cont" placeholder='Pesquisa')
            .column.col-auto
              .form-group
                small &nbsp;
                div
                  button.btn.btn-link.tooltip.tooltip-bottom(type='submit', :data-tooltip="$i18n.t('views.buttons.filter.label')")
                    i.fa.fa-search.fa-lg
      .column.col-auto
        router-link.btn.btn-action.s-circle(
          :to="{name: 'app.sistema.usuarioGrupos.form', params: { id: 'new' }}" 
          v-acl:allowed.admin.usuario_grupos.create
        )
          i.icon.icon-plus

    load-manager(:status="status")
      div
        table.table.table-striped.table-hover.table-sm
          thead
            tr
              th {{ $i18n.tModel('usuario_grupo.id')}}
              th {{ $i18n.tModel('usuario_grupo.nome')}}
              th
          tbody
            tr(v-for="item in list" :key='item.id' 
            )
              td \#{{item.id}}
              td {{item.nome}}
              td.text-right
                router-link(
                  :to="{ name: 'app.sistema.usuarioGrupos.form', params: { id: item.id } }"
                  v-acl:allowed.admin.usuario_grupos.update
                )
                  btn-icon.fa-lg(name='edit')
        .float-right
          paginator(:page='page', :pages='pages', @prev-page='prevPage', @next-page='nextPage'  color='#599940')
</template>

<script>
import listMixin, { vuexDefaultMapping } from '@/mixins/list'

export default {
  mixins: [listMixin],
  vuex: { usuarioGrupos: vuexDefaultMapping },

  computed: {
    nome_cont: {
      get() {
        return this.query.nome_cont
      },

      set(nome_cont) {
        this.setQuery({ ...this.query, nome_cont })
      },
    },
    excluido_eq: {
      get() {
        return this.query.excluido_eq
      },

      set(excluido_eq) {
        this.setQuery({ ...this.query, excluido_eq })
        this.fetchList()
      },
    },
  },
}
</script>
